export default "__VITE_ASSET__CDwwqGfC__"